<template>
    <div>
        <div class="col-xl-9 col-lg-10 col-md-12 pa-0" v-for="field in activeIntegration.fields">
            <div v-if="field.type == 'text' || field.type == 'password'">
                <v-text-field :type="field.type" outlined :label="field.label" v-model="$integrations.editedAddIntegration[field.key]" :rules="(field.rules)? field.rules : []"></v-text-field>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        computed:{
            activeIntegration(){
                return this.$integrations.activeIntegration;
            }
        },
        mounted(){
            var filled = 0;
            for(var i in this.$route.query){
                filled = filled + 1;
                this.$integrations.$set(this.$integrations.editedAddIntegration, i, this.$route.query[i]);
            }
            setTimeout(() => {
                if(filled > this.activeIntegration.fields.length){
                    this.$emit('filled');
                }
            },2000)
        }
    }
</script>
